/**
 * OAuth popups hand their result back with window.opener.postMessage from the
 * callback pages the API serves, so a genuine message always comes from the
 * API's origin. Any other window (e.g. one a malicious page opened) could post
 * a fake SMM_OAUTH_CODE / CHANNEL_OAUTH_SUCCESS / OAUTH_SUCCESS, so message
 * handlers ignore anything that fails isTrustedOAuthMessage.
 */

/** Origin the API (and so its OAuth callback pages) is served from. */
export function apiOrigin(
  apiBaseUrl: string | undefined = import.meta.env.VITE_API_BASE_URL,
  pageOrigin: string = window.location.origin,
): string {
  // A relative base URL ('/api/v1') means the API is on the dashboard's own origin.
  return new URL(apiBaseUrl || pageOrigin, pageOrigin).origin;
}

export function isTrustedOAuthMessage(event: MessageEvent, expectedOrigin: string = apiOrigin()): boolean {
  return event.origin === expectedOrigin;
}
